<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-motivo-atendimento") {
            next({ name: "ven-motivo-atendimento-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-motivo-atendimento") {
            this.$router.push({ name: "ven-motivo-atendimento-list" });
        }
    },
};
</script>